import React from 'react';
import accounting from 'accounting';
import _ from 'lodash';
import { CURRENCY, CURRENCYCLASSNAME } from '../../../helpers/variables';

const WizardTableCell = (props) => {
    if(props.isPremium){
        return(
            <td className="premiumSettingsWizard-table-data" key={props.realIndex}>
                {
                    props.isPlain?
                        <div className="premiumSettingsWizard-table-plain-cell">
                            { accounting.formatMoney(props.tableData[props.realIndex].premium, `${CURRENCY} `, 2)}
                        </div>
                        :
											<div className={CURRENCYCLASSNAME}>
                        <input
                            min={0.00}
                            value={
                                props.tableData[props.realIndex].premium === ''?
                                    '':
                                    _.round(props.tableData[props.realIndex].premium, 2)
                            }
                            required={true}
                            name="premium"
                            onChange={(evt) => props.handlePremiumAndUnderwriterChange(evt.target.name, evt.target.value, props.realIndex)}
                            className="formGroupTableRow-textInput-input col-sm-11"
                            type="number"
                            step="0.01"
                        />
											</div>
                }
        </td>
        )
    }
    if(props.isRecoverable){
        return (<td className="premiumSettingsWizard-table-data" key={props.realIndex}>
                {
                    props.isPlain?
                        <div className="premiumSettingsWizard-table-plain-cell">
                            { accounting.formatMoney(props.tableData[props.realIndex].recoverable, `${CURRENCY} `, 2)}
                        </div>
                        :
                                <div className={CURRENCYCLASSNAME}>
                        <input
                            min={0.00}
                            value={
                                props.tableData[props.realIndex].recoverable === ''?
                                    ''
                                    :
                                    _.round(props.tableData[props.realIndex].recoverable, 2)
                            }
                            required={true}
                            name="recoverable"
                            onChange={(evt) => props.handleRecoverableAndNonRecoverableChange(evt.target.name, evt.target.value, props.realIndex)}
                            className="formGroupTableRow-textInput-input col-sm-11"
                            type="number"
                            step="0.01"
                        />
											</div>
                }
            </td>
        )
    }
    if(props.isNonRecoverable){
        return (<td className="premiumSettingsWizard-table-data" key={props.realIndex}>
                {
                    props.isPlain?
                        <div className="premiumSettingsWizard-table-plain-cell">
                            { accounting.formatMoney(props.tableData[props.realIndex].nonRecoverable, `${CURRENCY} `, 2)}
                        </div>
                        :
                                    <div className={CURRENCYCLASSNAME}>
                        <input
                            min={0.00}
                            value={
                                props.tableData[props.realIndex].nonRecoverable === ''?
                                    ''
                                    :
                                    _.round(props.tableData[props.realIndex].nonRecoverable, 2)
                            }
                            required={true}
                            name="nonRecoverable"
                            onChange={(evt) => props.handleRecoverableAndNonRecoverableChange(evt.target.name, evt.target.value, props.realIndex)}
                            className="formGroupTableRow-textInput-input col-sm-11"
                            type="number"
                            step="0.01"
                        />
											</div>
                }
            </td>
        )
    }
    if(props.isUnderwriter) {
        return (
            <td key={props.index} className="premiumSettingsWizard-table-data">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="col-sm-6  wrapperNoPaddingLeft">
                            {
                                props.isPlain?
                                    <div className="premiumSettingsWizard-table-plain-cell">
                                        { accounting.formatMoney(props.tableData[props.realIndex].underwriterRate, `${CURRENCY} `, 2)}
                                    </div>
                                    :
                                            <div className={CURRENCYCLASSNAME}>
                                        <input
                                            min={0.00}
                                            value={
                                                props.tableData[props.realIndex].underwriterRate === ''?
                                                    ''
                                                    :
                                                    _.round(props.tableData[props.realIndex].underwriterRate, 2)
                                            }
                                            max={props.tableData[props.realIndex].premium}
                                            required={true}
                                            name="underwriterRate"
                                            onChange={(evt) => props.handlePremiumAndUnderwriterChange(evt.target.name, evt.target.value, props.realIndex)}
                                            className="formGroupTableRow-textInput-input col-sm-10 "
                                            type="number"
                                            step="0.01"
                                        />
                                    </div>

                            }
                        </div>
                        <div className="col-sm-6 wrapperNoPaddingRight">
                            {
                                props.isPlain?
                                    <div className="premiumSettingsWizard-table-plain-cell">{_.round(props.tableData[props.realIndex].underwriterRatePercentage, 2)+ '%'}</div>
                                    :
                                    <div className="percentInput">
                                        <input
                                            min={0.00}
                                            max={100.00}
                                            value={
                                                props.tableData[props.realIndex].underwriterRatePercentage === ''?
                                                    ''
                                                    :
                                                    _.round(props.tableData[props.realIndex].underwriterRatePercentage, 2)
                                            }
                                            required={true}
                                            name="underwriterRatePercentage"
                                            onChange={(evt) => props.handlePremiumAndUnderwriterChange(evt.target.name, evt.target.value, props.realIndex)}
                                            className="formGroupTableRow-textInput-input col-sm-10 "
                                            type="number"
                                            step="0.01"
                                        />
                                    </div>
                            }
                        </div>
                    </div>
                </div>
            </td>
        )
    } else {
        return(
            <td key={props.index} className="premiumSettingsWizard-table-data">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="col-sm-6  wrapperNoPaddingLeft">
                            {
                                props.tableData[props.realIndex].premiumSubSettingCommissions[props.solicitorIndex]?
                                props.isPlain?
                                    <div className="premiumSettingsWizard-table-plain-cell">
                                        { accounting.formatMoney(props.tableData[props.realIndex].premiumSubSettingCommissions[props.solicitorIndex].commission, `${CURRENCY} `, 2)}
                                    </div>
                                    :
                                    <div className={CURRENCYCLASSNAME}>
                                        <input
                                            min={0.00}
                                            max={props.tableData[props.realIndex].premium}
                                            id={'sol' + props.realIndex + props.solicitorIndex + 'commission'}
                                            value={
                                                props.tableData[props.realIndex].premiumSubSettingCommissions[props.solicitorIndex].commission === ''?
                                                    ''
                                                    :
                                                    _.round(props.tableData[props.realIndex].premiumSubSettingCommissions[props.solicitorIndex].commission, 2)
                                            }
                                            required={true}
                                            name="commission"
                                            onChange={(evt) => props.handleCommissionChange(evt.target.name, evt.target.value, props.realIndex, props.solicitorIndex)}
                                            className="formGroupTableRow-textInput-input col-sm-10 "
                                            type="number"
                                            step="0.01"
                                        />
                                    </div>
                                    :
                                    null
                            }
                        </div>
                        <div className="col-sm-6 wrapperNoPaddingRight">
                            {
                                props.isPlain?
                                    <div className="premiumSettingsWizard-table-plain-cell">{
                                        _.round(props.tableData[props.realIndex].premiumSubSettingCommissions[props.solicitorIndex].commissionPercentage, 2) + '%'
                                    }</div>
                                    :
                                    <div className="percentInput">
                                        <input
                                            min={0.00}
                                            max={100.00}
                                            id={'sol' + props.realIndex + props.solicitorIndex + 'commissionPercentage'}
                                            value={
                                                props.tableData[props.realIndex].premiumSubSettingCommissions[props.solicitorIndex].commissionPercentage === ''?
                                                    ''
                                                    :
                                                    _.round(props.tableData[props.realIndex].premiumSubSettingCommissions[props.solicitorIndex].commissionPercentage, 2)
                                            }
                                            required={true}
                                            name="commissionPercentage"
                                            onChange={(evt) => props.handleCommissionChange(evt.target.name, evt.target.value, props.realIndex, props.solicitorIndex)}
                                            className="formGroupTableRow-textInput-input col-sm-10 "
                                            type="number"
                                            step="0.01"
                                        />
                                    </div>
                            }
                        </div>
                    </div>
                </div>
            </td>
        )
    }

};

export default WizardTableCell;